// src/services/recipeService.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  RECIPE_DETAILS,
  RECIPE_DOWNLOAD,
  RECIPE_LIST,
  RECIPE_ADD,
  RECIPE_UPDATE,
  RECIPE_DELETE,
  RECIPE_IMPORT,
  RECIPE_EXPORT,
  RECIPE_DELETE_ALL,
} from "../../config/constants"; // Adjust endpoints as per your config

const recipeService = createApi({
  reducerPath: "recipeService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["Recipe"],
  endpoints: (builder) => ({
    getRecipes: builder.query({
      query: (bodyData) => ({
        url: RECIPE_LIST, // Endpoint to fetch recipe list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["Recipe"],
    }),
    getRecipeDetails: builder.query({
      query: (id) => ({
        url: `${RECIPE_DETAILS}/${id}`, // Endpoint to fetch recipe details
        method: "GET",
      }),
    }),
    addRecipe: builder.mutation({
      query: (recipeData) => ({
        url: RECIPE_ADD, // Endpoint to add a recipe
        method: "POST",
        data: recipeData, // Recipe data for the request body
      }),
      invalidatesTags: ["Recipe"],
    }),
    updateRecipe: builder.mutation({
      query: ({ recipeId, updatedData }) => ({
        url: `${RECIPE_UPDATE}/${recipeId}`, // Endpoint to update a recipe
        method: "PUT",
        data: updatedData, // Updated recipe data
      }),
      invalidatesTags: ["Recipe"],
    }),
    deleteRecipe: builder.mutation({
      query: (recipeId) => ({
        url: `${RECIPE_DELETE}/${recipeId}`, // Endpoint to delete a recipe
        method: "DELETE",
      }),
      invalidatesTags: ["Recipe"],
    }),
    downloadRecipe: builder.mutation({
      query: (recipeData) => ({
        url: RECIPE_DOWNLOAD, // Endpoint to add a recipe
        method: "POST",
        data: recipeData, // Recipe data for the request body
      }),
    }),
    importRecipe: builder.mutation({
      query: (data) => ({
        url: `${RECIPE_IMPORT}`, // Endpoint to update a settings
        method: "POST",
        data: data, // Updated settings data
        headers: {
          "content-type": "multipart/form-data",
        },
      }),
      invalidatesTags: ["Recipe"],
    }),
    getRecipeExportFile: builder.mutation({
      query: (bodyData) => ({
        url: RECIPE_EXPORT, // Endpoint to fetch ingredient list
        method: "GET",
      }),
    }),
    deleteAllRecipe: builder.mutation({
      query: (bodyData) => ({
      //  url: `${INGREDIENT_DELETE}/${ingredientId}`, // Endpoint to delete a ingredient
        url: RECIPE_DELETE_ALL,
        method: "DELETE",
      }),
      invalidatesTags: ["Recipe"],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetRecipesQuery,
  useGetRecipeDetailsQuery,
  useAddRecipeMutation,
  useUpdateRecipeMutation,
  useDeleteRecipeMutation,
  useDownloadRecipeMutation,
  useImportRecipeMutation,
  useGetRecipeExportFileMutation,
  useDeleteAllRecipeMutation,
} = recipeService;

// Export the reducer to be included in the store
export default recipeService;
